"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BouncerAbilityHandler = exports.BouncerActorAbilityFactory = exports.BouncerAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const Duration_1 = require("../../core/Duration");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Record_1 = require("../../utils/Record");
const enums_1 = require("../../core/enums");
class BouncerAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bouncer;
        this.__typeName = "Bouncer";
    }
}
exports.BouncerAbilityArgs = BouncerAbilityArgs;
let BouncerActorAbilityFactory = class BouncerActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bouncer", "Self", 3);
    }
};
BouncerActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bouncer")
], BouncerActorAbilityFactory);
exports.BouncerActorAbilityFactory = BouncerActorAbilityFactory;
let BouncerAbilityHandler = class BouncerAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        container.unsummonAllSummonedCompanions(sequence, ability.invokerId);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated() {
                const bouncerArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.GamblerBouncer, invoker.level, 
                // attributes...
                Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
                    let multiplier = .75;
                    switch (+key) {
                        case AttributeType_1.AttributeType.Power:
                            value = (0, Record_1.getValueOrDefault)(invoker.maxAttributeValues, AttributeType_1.AttributeType.Focus, 0);
                            break;
                        case AttributeType_1.AttributeType.Focus:
                            value = (0, Record_1.getValueOrDefault)(invoker.maxAttributeValues, AttributeType_1.AttributeType.Power, 0);
                            break;
                    }
                    pet[key] = Math.round(value * multiplier);
                    return pet;
                }, {}), {
                    [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("Backhand").mk()
                })
                    .withPlayerId(invoker.playerId);
                container.summonCompanion(sequence, ability.invokerId, bouncerArgs, Duration_1.Duration.Permanent);
            }
        });
    }
};
BouncerAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bouncer)
], BouncerAbilityHandler);
exports.BouncerAbilityHandler = BouncerAbilityHandler;
